import Box from '@mui/material/Box';
/* eslint-disable */
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Tooltip from '@mui/material/Tooltip';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import { useMediaQuery, useTheme } from '@mui/material';
import { gridSpacing } from 'store/constant';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Spin } from 'antd';
import { Space } from 'antd';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import { HomeOutlined } from '@ant-design/icons';
import { Typography } from '@mui/material';
import { Modal, Row, Col } from 'antd';
import { Button as AntButton } from 'antd';
import { handleCatchError } from 'utils/CatchHandler';
import GlobalBackButton from 'views/utilities/BackButtonGlobal';
import { useSelector } from 'react-redux';
import { globalNotifyError, globalNotifySuccess } from 'views/utilities/AlertToast';
import BcConvertModal from 'views/Components/BcConvertModal';
import Spinner from 'views/Components/LoadingSinner';

import {
    generateOtpApi,
    getDmtChargesApi,
    getIservueLimitApi,
    indexVerifySenderAPI,
    loadTransferApi,
    moneytransferBenefDetailsApi
} from 'utils/API/Merchant APIs/DmtApiCalls';
import { checkMerchantOrBCAPI, getPremiumBcChargesNewApi } from 'utils/API/Merchant APIs/MerchantApiCalls';
import { setDisablerFalse, setDisablerTrue } from 'redux/SidebarDisablerSlice';
import { useDispatch } from 'react-redux';
import FundTransferEkyc from './DmtEkycComponent/FundTransferEkyc';
import CommissionDisplayComponent from '../CommissionDisplayComponent';
import {
    useFetchBeneficiaryList,
    useFetchCustomerList,
    generateTxnOtp,
    getCustomerLimit,
    fundTransferApi,
    getChargesDMTTransferApi
} from 'utils/API/Merchant APIs/UpdatedAPIs/DMTUpdatedAPICalls';

const commonStyles = {
    m: 0
};

export default function DenseTable() {
    const shouldshowEsign = localStorage.getItem('shouldshowEsign');
    const theme = useTheme();
    const dispatch = useDispatch();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [paymentMode, setPaymentMode] = useState('IMPS');
    const [selectedBenefData, setSelectedBenefData] = useState('');
    const [amountResponse, setAmountResponse] = useState('');
    const [amountError, setAmountError] = useState(false);
    //Dropdown helpers
    const [customer, setCustomer] = useState('');
    const [beneficiary, setBeneficiary] = useState('');
    //Arrays to map
    const [customerMap, setCustomerMap] = useState([]);
    const [beneficiaryMap, setBeneficiaryMap] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [choosedBenef, setChoosedBenef] = useState(null);

    //State to store amount
    const [tamount, setTamount] = useState();
    //Is loading state for button change
    const [isLoading, setIsLoading] = useState(false);
    const [maxLimitLoading, setMaxLimitLoading] = useState(false);
    const [senderno, setSenderno] = useState('');
    const [maxLimit, setMaxLimit] = useState(0);
    //State to check the transfer is success
    const isSuccess = true;
    const isFirstRender = true;
    const [isTrue, setIsTrue] = useState(false);
    const [isFailed, setIsFailed] = useState(false);
    const [isFailedMessage, setIsFailedMessage] = useState('');
    const [benifId, setBenifId] = useState('');
    const [showOtpField, setShowOtpField] = useState(false);
    const [otpReferenceId, setOtpRefrenceId] = useState('');
    const location = useLocation();
    const navigate = useNavigate();
    const CreateCustomerRes = location?.state?.Data;
    const transfer = 'iserveu';
    const id = location?.state?.data?.id || location?.state?.data?.data[0]?.id;
    const indexBenef = location?.state?.indexBenef;

    const benefId = location?.state?.row?.benefId;
    const uid = localStorage.getItem('id');
    const email = localStorage.getItem('email_id');
    const data = location?.state?.item || location?.state?.data;

    const customerId = location?.state?.item || location?.state?.data?.id;
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [hasNextPage, setHasNextPage] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const type = 'fino';
    const benAcc = choosedBenef?.accountNumber;
    const amount = amountResponse?.amount;
    //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

    //States and handlers for modal component
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [merchantModalOpen, setMerchantModalOpen] = useState(false);
    const [isBcConvertPending, setIsBcConvertPending] = useState(false);
    const [isCheckLoading, setIsCheckLoading] = useState(true);
    const [plansToDisplay, setPlansToDisplay] = useState({ normal: {}, silver: {}, gold: {} });

    // const [modalText, setModalText] = useState('Content of the modal');

    //w1 balance
    const balanceW1 = useSelector((state) => state?.wallet?.balance?.roundedNumber);
    const handleTransferClick = () => {
        setIsFailedMessage('');
        setIsFailed(false);
        if (tamount >= 100) {
            fetchValues();
        } else {
            setAmountError('The minimum transfer amount is 100!');
        }
    };
    const showModal = () => {
        if (customer && beneficiary && tamount) {
            setOpen(true);
        } else {
            globalNotifyError('Make sure you have filled all the fields!');
            setIsLoading(false);
        }
    };
    const handleOk = () => {
        setConfirmLoading(true);
        handleGenerateOtp();
        handleCancel();
    };
    const handleCancel = () => {
        setConfirmLoading(false);
        setOpen(false);
        dispatch(setDisablerFalse());
    };

    //STATE MANAGEMENT>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

    //Functions to API calls>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    const getPremiumPlansAndCharges = async () => {
        const agentid = localStorage.getItem('id');
        const payload = { agentid };
        const response = await getPremiumBcChargesNewApi(payload);
        const data = response?.data?.data;
        const normalPlan = data?.find((item) => item.id === 1);
        const silverPlan = data?.find((item) => item.id === 3);
        const goldPlan = data?.find((item) => item.id === 2);
        setPlansToDisplay({ normal: normalPlan, silver: silverPlan, gold: goldPlan });
    };

    const customerDetails = async (pageNumber = 1) => {
        try {
            const response = await useFetchBeneficiaryList(2, customerId, pageNumber, limit);

            const { response: customerApiResponse } = await useFetchCustomerList('iServeu');

            const customerList = customerApiResponse?.data?.data || [{}];
            const benefData = response?.data?.data.result || [];
            const hasNext = response?.data?.data?.pagination?.hasNextPage;

            setCustomerMap(customerList);
            setBeneficiaryMap((prev) => (pageNumber === 1 ? benefData : [...prev, ...benefData]));

            setHasNextPage(hasNext);

            setLoadingMore(false);
        } catch (error) {
            console.log(error.message);
            handleCatchError(error);
            setLoadingMore(false);
        }
    };

    //Api to fetch values when amount entered
    const fetchValues = async () => {
        // const serviceType = 'DMT';
        setIsTrue(true);
        const dmtType = 2;
        try {
            const payload = { dmtType, paymentMode, amount: Number(tamount) };
            const values = await getChargesDMTTransferApi(payload);

            setAmountResponse(values?.data?.data);
            showModal();
            setIsTrue(false);
            showModal();
        } catch (error) {
            console.log(error.message);
            setIsTrue(false);
            handleCatchError(error);
        }
    };

    //Api to fetch data of single beneficiary on change of dropdown
    const fetchBenefDetails = async () => {
        const type = transfer;
        const id = beneficiary;
        try {
            const payload = { email, type, id, senderno };
            const singleBenefData = await loadTransferApi(payload);
            const detailsOfBenef = singleBenefData?.data?.data;
            setSelectedBenefData(detailsOfBenef);
            setBenifId(detailsOfBenef?.id);
        } catch (error) {
            console.log(error.message);
            handleCatchError(error);
        }
    };
    //UPDATE BENEFICIARY AS PER THE SELECTED CUSTOMER
    // const updateBeneficiary = async () => {
    //     try {
    //         const payload = { uid, email, senderno, type };
    //         const response = await moneytransferBenefDetailsApi(payload);
    //         const benefData = response?.data?.data?.benfDetails;
    //         setBeneficiaryMap(benefData);
    //     } catch (error) {
    //         console.log(error);
    //         handleCatchError(error);
    //     }
    // };

    const checkMerchantBC = async () => {
        setIsCheckLoading(true);
        const agentid = localStorage.getItem('id');

        const payloadCheck = { agentid };
        const merchantBcCheckResponse = await checkMerchantOrBCAPI(payloadCheck);
        setIsCheckLoading(false);
        const agentType = merchantBcCheckResponse?.data?.agentType;
        const pendingStatus = merchantBcCheckResponse?.data?.isPending;
        setIsBcConvertPending(pendingStatus);

        if (agentType === 'Merchant' || pendingStatus || shouldshowEsign === 'true') {
            setMerchantModalOpen(true);

            return;
        }
        //CHECKING ENDS HERE
    };
    const getTransactionLimit = async () => {
        try {
            setMaxLimitLoading(true);
            const customerMobileNo = data?.mobileNumber;
            const dmtType = 2;
            const payload = { customerMobileNo, dmtType };
            const response = await getCustomerLimit(payload);

            const maximumLimit = response?.data?.data?.limit;
            if (maximumLimit >= 0) {
                setMaxLimitLoading(false);
                setMaxLimit(maximumLimit);
            } else {
                setMaxLimitLoading(false);
                setMaxLimit(0);
            }
            setMaxLimitLoading(false);
        } catch (error) {
            setMaxLimitLoading(false);
            console.log(error.message);
            handleCatchError(error);
        }
    };
    //otp api
    const handleGenerateOtp = async () => {
        try {
            setIsLoading(true);
            const agentid = localStorage.getItem('id');
            const customerId = id;
            const beneName = choosedBenef?.beneficiaryFirstName;
            const paymentMode = 'IMPS';
            const beneAccountNo = benAcc;
            const dmtType = 2;
            const payload = {
                agentid: 2,
                beneName,
                customerId,
                beneAccountNo,
                amount: Number(tamount),
                dmtType,
                paymentMode
            };
            console.log('payload', payload);

            const response = await generateTxnOtp(payload);

            if (response?.data?.success) {
                globalNotifySuccess(response?.data?.message);
                setOtpRefrenceId(response?.data?.data?.otpReferenceID);
                setShowOtpField(true);
            } else {
                // handleClose();
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.log(error.message);
            handleCatchError(error);
        }
    };
    //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    //FUNCTION TO FETCH SENDER NUMBER ON CUSTOMER CHANGE
    //EVENT HANDLERS>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    const handleModeChange = (event) => {
        event.preventDefault();
        setPaymentMode(event.target.value);
    };
    const handleBeneficiaryChange = (event, newValue) => {
        if (newValue?.id) {
            setBeneficiary(newValue?.id);
            setChoosedBenef(newValue);
        }
    };
    const handleAmountChange = (e) => {
        setAmountError(false);
        const amountValue = e?.target?.value;
        const amountValueFloat = parseFloat(amountValue);
        const balanceW1Float = parseFloat(balanceW1);

        if (amountValueFloat > 0) {
            if (amountValueFloat <= balanceW1Float) {
                setTamount(amountValue);
            } else {
                setAmountError('Entered amount exceeds the wallet balance!');
            }
        } else {
            setAmountError('Please enter a valid amount.');
        }
        // if (amountValueFloat > 0) {
        //     if (amountValue <= maxLimit) {
        //         setTamount(amountValue);
        //     } else {
        //         setAmountError('The entered amount exceeds the maximum limit');
        //     }
        // } else {
        //     setAmountError('Please enter a valid amount.');
        // }
    };

    const handleAddBenefClick = () => {
        navigate('/moneyTransfer2/createBeneficiary', { state: { data: selectedCustomer } });
    };
    const handleBcModalClose = () => {
        setMerchantModalOpen(false);
    };
    useEffect(() => {
        if (open) {
            dispatch(setDisablerTrue());
        }
        // eslint-disable-next-line
    }, [open]);

    useEffect(() => {
        if (senderno && customer && customerId) {
            setPage(1);
            customerDetails(1);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customer, customerId, senderno]);

    //calling  transaction limit api to reassurance of loading of transaction limit>>>>>>>>>
    useEffect(() => {
        if (senderno) {
            getTransactionLimit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [senderno, customer]);

    useEffect(() => {
        checkMerchantBC();
        getPremiumPlansAndCharges();
        if (CreateCustomerRes) {
            globalNotifySuccess('Customer created successfully');
        }
        const allCustomers = location?.state?.filteredData;
        const filteredCustomer = allCustomers?.filter((data) => data?.id === id);
        if (filteredCustomer?.length > 0) {
            const number = filteredCustomer[0]?.mobileNumber;
            setSenderno(number);
        } else {
        }
        if (location?.state?.senderno) {
            setSenderno(location?.state?.senderno);
        }
        setCustomer(id);
        const beneficiaryFromNavigate = location?.state?.row ? location?.state?.row?.id : '';
        setBeneficiary(beneficiaryFromNavigate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (tamount >= 100) {
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tamount]);
    // useEffect(() => {
    //     if (beneficiary) {
    //         fetchBenefDetails();
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [beneficiary]);
    useEffect(() => {
        if (isFailed) {
            // notify();
            globalNotifyError(isFailedMessage);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFailed]);

    // useEffect hook to select the first option on first render
    useEffect(() => {
        if (isFirstRender && customerMap && customerMap?.length > 0) {
            const filteredSingleCustomer = customerMap?.filter((item) => item?.id == id);
            setSelectedCustomer(filteredSingleCustomer[0]); // Select the default option
        }
        if (location?.state?.data) {
            let customerData;
            if (location?.state?.data?.data) {
                customerData = location?.state?.data?.data[0];
            } else {
                customerData = location?.state?.data;
            }
            setSelectedCustomer(customerData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerMap]);

    // useEffect hook to select the first option on first render
    useEffect(() => {
        if (beneficiaryMap?.length > 0 && indexBenef) {
            const matchedBenef = beneficiaryMap.find((item) => item.id === indexBenef);
            if (matchedBenef) {
                setChoosedBenef(matchedBenef);
            }
        }
    }, [beneficiaryMap]);

    const handleCloseModal = () => {
        setShowOtpField(false);
    };

    return (
        <>
            {/* <<<<<<<Breadcrumb starts here>>>>>> */}
            <Box
                sx={{
                    width: '100%',
                    height: 'auto',
                    backgroundColor: '#fff',
                    ...commonStyles,
                    // flex: Grid,
                    borderRadius: 2,
                    boxShadow: 2,
                    padding: '20px 10px',
                    '@media screen and (min-width: 600px)': {
                        padding: 2,
                        marginBottom: 2
                    }
                }}
            >
                <Grid container spacing={gridSpacing}>
                    <Grid item lg={12} md={6} sm={6} xs={12}>
                        <Typography variant="h3">
                            {' '}
                            <GlobalBackButton /> Domestic Money Transfer{' '}
                        </Typography>
                    </Grid>
                </Grid>
                <Box sx={{ marginTop: '10px' }}>
                    <Link to="/merchant-home" style={{ textDecoration: 'none', color: 'inherit' }}>
                        <HomeOutlined />
                    </Link>

                    <Typography component="span" style={{ margin: '0 10px' }}>
                        &gt;
                    </Typography>
                    <Link to="/moneyTransfer2/viewCustomers" style={{ textDecoration: 'none', color: 'inherit' }}>
                        View Customers
                    </Link>
                    <Typography component="span" style={{ margin: '0 10px' }}>
                        &gt;
                    </Typography>
                    <Typography component="span">Transfer page</Typography>
                </Box>
                <Box sx={{ marginTop: '20px' }}>
                    <Grid container spacing={gridSpacing}>
                        <Grid item lg={4} md={6} sm={6} xs={12}>
                            <Chip
                                color="info"
                                label={`Selected Customer: ${selectedCustomer ? selectedCustomer?.customerName : ''}`}
                                sx={{ fontWeight: 'bold' }}
                            />
                        </Grid>
                        <Grid item lg={4} md={6} sm={6} xs={12}>
                            {/* <Chip color="success" label={`Transaction Limit : ₹ ${maxLimit}`} sx={{}} /> */}
                        </Grid>
                        <Grid item lg={4} md={6} sm={6} xs={12}>
                            {maxLimitLoading ? (
                                <Chip color="warning" label="Loading..." sx={{}} />
                            ) : (
                                <Chip color="warning" label={`Transaction Limit : ₹ ${maxLimit}`} sx={{}} />
                            )}
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            {/* <<<<<<<Breadcrumb end here>>>>>>> */}
            <Box
                sx={{
                    width: '100%',
                    height: 'auto',
                    backgroundColor: '#fff',
                    padding: isMobile ? '20px 10px' : 2,
                    boxShadow: 2,
                    borderRadius: 3
                }}
            >
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item lg={3} md={6} sm={6} xs={6}>
                                <h5>{senderno ? 'SENDER MOBILE : ' + senderno : 'SENDER MOBILE : ' + '-'}</h5>
                            </Grid>
                            <Grid item lg={3} md={6} sm={6} xs={6}>
                                <h5>
                                    {choosedBenef?.accountNumber
                                        ? 'BENEFICIARY A/C : ' + choosedBenef?.accountNumber
                                        : 'BENEFICIARY A/C : ' + '-'}
                                </h5>
                            </Grid>
                            <Grid item lg={3} md={6} sm={6} xs={6}>
                                <h5>
                                    {choosedBenef?.ifscCode ? 'BENEFICIARY IFSC : ' + choosedBenef?.ifscCode : 'BENEFICIARY IFSC : ' + '-'}
                                </h5>
                            </Grid>
                            <Grid item lg={3} md={6} sm={6} xs={6}>
                                <h5>
                                    {choosedBenef?.mobileNumber
                                        ? 'BENEFICIARY Mobile : ' + choosedBenef?.mobileNumber
                                        : 'BENEFICIARY Mobile : ' + '-'}
                                </h5>
                            </Grid>

                            <Grid item lg={4} md={6} sm={6} xs={12}>
                                <Stack direction="row" spacing={2}>
                                    <Box sx={{ minWidth: 200, maxWidth: 200, pt: 2 }}>
                                        <FormControl fullWidth style={{ minWidth: 200 }}>
                                            <InputLabel htmlFor="demo-simple-select-label">IMPS/NEFT</InputLabel>
                                            <Select
                                                labelid="demo-simple-select-label"
                                                id="demo-simple-select-label"
                                                value={paymentMode}
                                                label="mode"
                                                onChange={handleModeChange}
                                            >
                                                <MenuItem value="IMPS">IMPS</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Stack>
                            </Grid>
                            <Grid item lg={4} md={6} sm={6} xs={12}>
                                <Stack direction="row" spacing={2}>
                                    <Box sx={{ minWidth: 200, maxWidth: 200, pt: 2 }}>
                                        <Autocomplete
                                            options={beneficiaryMap}
                                            value={choosedBenef}
                                            onChange={handleBeneficiaryChange}
                                            getOptionLabel={(option) =>
                                                `${option?.beneficiaryFirstName || ''} ${option?.beneficiaryLastName || ''}`
                                            }
                                            ListboxProps={{
                                                onScroll: (event) => {
                                                    const listboxNode = event.currentTarget;

                                                    if (!hasNextPage || loadingMore) return;

                                                    const isBottom =
                                                        listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 10;

                                                    if (isBottom) {
                                                        const nextPage = page + 1;
                                                        setLoadingMore(true);
                                                        setPage(nextPage);
                                                        customerDetails(nextPage);
                                                    }
                                                }
                                            }}
                                            renderInput={(params) => <TextField {...params} label="Beneficiary" />}
                                        />
                                    </Box>
                                    <Box sx={{ pt: 3, '& > :not(style)': {} }}>
                                        <Tooltip title="Click to add new beneficiary">
                                            {/* <Link to="/dmt/Checkbeneficiary"> */}
                                            <AntButton onClick={handleAddBenefClick} shape="circle" type="primary" icon={<AddIcon />} />
                                            {/* </Link> */}
                                        </Tooltip>
                                    </Box>
                                </Stack>
                            </Grid>
                            <Grid item lg={4} md={6} sm={6} xs={12}>
                                <Stack sx={{ pt: 2 }} direction="row">
                                    <Box
                                        component="form"
                                        sx={{
                                            '& > :not(style)': { m: 1, width: '25ch' }
                                        }}
                                        noValidate
                                        autoComplete="off"
                                    ></Box>
                                    <TextField
                                        id="outlined-basic"
                                        label="Amount"
                                        variant="outlined"
                                        error={Boolean(amountError)}
                                        helperText={amountError}
                                        onChange={handleAmountChange}
                                    />
                                    {isTrue ? (
                                        <Space
                                            direction="vertical"
                                            style={{
                                                width: '20%',
                                                paddingTop: 20
                                            }}
                                        >
                                            <Spin size="large">
                                                <div className="content" />
                                            </Spin>
                                        </Space>
                                    ) : null}
                                </Stack>
                            </Grid>

                            <h4 style={{ paddingLeft: 40, color: 'red' }}>{!isSuccess ? 'Money transfer failed' : null}</h4>
                            <Grid item lg={12} md={6} sm={6} xs={3}>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    disabled={Boolean(amountError) || Boolean(isLoading)}
                                    onClick={handleTransferClick}
                                    fullWidth
                                >
                                    {isLoading ? 'Loading...' : 'Transfer'}
                                </Button>
                                <Modal
                                    title={<Chip color="info" label={'CONFIRM MONEY TRANSFER DETAILS '} sx={{}} />}
                                    open={open}
                                    onOk={handleOk}
                                    okText="Confirm and Pay"
                                    confirmLoading={confirmLoading}
                                    onCancel={handleCancel}
                                    width="85%"
                                >
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <p>Customer Name: {selectedCustomer?.customerName || ''}</p>
                                            <p>Date: {new Date().toDateString().split(' ').slice(1).join(' ')}</p>
                                            <p>Beneficiary A/C : {choosedBenef ? choosedBenef?.accountNumber : ''}</p>
                                            <p>Service Charge : {amountResponse?.newserviceCharge ?? '0'}</p>
                                            <p>GST : {amountResponse?.gst ?? '0'}</p>
                                        </Col>

                                        <Col span={12}>
                                            <p>Beneficiary Name: {choosedBenef?.beneficiaryFirstName}</p>
                                            <p>Payment Mode: {paymentMode}</p>
                                            <p>Beneficiary IFSC : {choosedBenef ? choosedBenef?.ifscCode : ''}</p>
                                            <p>Effective Commission : {amountResponse?.agent_commission ?? '0'}</p>
                                            <p>TDS : {amountResponse?.tds ?? '0'}</p>
                                            {plansToDisplay.gold.upgradeStatus === 1 && (
                                                <p>Total Commission : {amountResponse?.totCommi ?? '0'}</p>
                                            )}
                                            {/* <p>Total Debit Amount : {amountResponse ? amountResponse.agentDebitAmount : ''}</p> */}
                                        </Col>
                                    </Row>
                                    {plansToDisplay.normal.upgradeStatus === 1 || plansToDisplay.silver.upgradeStatus === 1 ? (
                                        <CommissionDisplayComponent
                                            amountResponse={amountResponse}
                                            isSilver={plansToDisplay.silver.upgradeStatus === 1}
                                        />
                                    ) : null}
                                    <p style={{ fontWeight: 'bold' }}>Total Debit Amount: ₹ {amountResponse?.agentDebitAmount ?? '0'}</p>
                                </Modal>
                            </Grid>
                            {/* </Stack> */}
                        </Grid>
                    </Grid>
                </Grid>
            </Box>

            <ToastContainer />
            {merchantModalOpen && (
                <BcConvertModal
                    isOpen={merchantModalOpen}
                    handleclose={handleBcModalClose}
                    isPending={isBcConvertPending}
                    shouldshowEsign={shouldshowEsign}
                />
            )}
            {showOtpField && (
                <FundTransferEkyc
                    showModal={showOtpField}
                    id={id}
                    benAcc={benAcc}
                    beneName={choosedBenef?.beneficiaryFirstName}
                    beneId={choosedBenef?.id}
                    amount={amount}
                    paymentMode={paymentMode}
                    data={data}
                    otp_reference={otpReferenceId}
                    closeModalView={handleCloseModal}
                />
            )}
            <Spinner loading={isCheckLoading} />
        </>
    );
}
